export default __webpack_public_path__ + "static/media/twitter.cc669d79.svg";